/**
 * Google Maps Script with bot protection toggle
 * 
 * To use the optimized version (with bot blocking):
 * import GoogleMapsScript from 'components/scripts/GoogleMapsScript';
 * 
 * To force the original version:
 * import { GoogleMapsScriptOriginal as GoogleMapsScript } from 'components/scripts/GoogleMapsScript';
 */

import GoogleMapsScriptOriginal from './GoogleMapsScriptOriginal';
import GoogleMapsScriptOptimized from './GoogleMapsScriptOptimized';

// Master switch - set to false to use original implementation everywhere
const USE_OPTIMIZED_VERSION = true;

// Export the appropriate version based on the master switch
const GoogleMapsScript = USE_OPTIMIZED_VERSION ? GoogleMapsScriptOptimized : GoogleMapsScriptOriginal;

export default GoogleMapsScript;

// Always export both versions for testing
export { GoogleMapsScriptOriginal };
export { GoogleMapsScriptOptimized };